/*
DO NOT MANUALLY TRANSLATE!
Follow the instructions in the README.md to conveniently update translations.
*/

export default {
  "CookieMessage.old.link": "Lisätietoa",
  "CookieMessage.old.text":
    "Käytämme evästeitä helpottaaksemme sivuston käyttöä. Tutustu evästekäytäntöömme.",
  "CookieMessage.link": "Hyväksy evästeet",
  "CookieMessage.more_information": "Lue lisää Kramp evästeistä",
  "CookieMessage.return": "Takaisin",
  "CookieMessage.intro.body":
    "Evästeet ovat Krampin ja kolmansien osapuolten asettamia. On sanomattakin selvää, että pidämme yksityisyydestäsi hyvää huolta. Klikkaamalla Hyväksy evästeet alla, hyväksyt evästeiden käytön ja varmistat että sivustomme toimii oikein. Esimerkkejä evästeistä ja niiden käystöstä:",
  "CookieMessage.intro.list.1": "Automaattinen kirjautuminen Omalle tilille",
  "CookieMessage.intro.list.2":
    "Käyttäjien toiminnan analysointi verkkokaupan kehittämisen tueksi",
  "CookieMessage.intro.list.3":
    "Asiakasprofiilien luominen, jotta voimme tarjota asiakkaillemme räätälöityä tietoa ja mainontaa",
  "CookieMessage.intro.extra":
    'Mikäli et halua hyväksyä kaikkia evästeitä, voit muuttaa asetuksia tästä <a>asetukset</a>. Lisätietoja evästeiden käytöstä löydät täältä <a href="{legalLink}">yksityisyydensuoja ja evästeet</a>',
  "CookieMessage.intro.title": "Kramp käyttää evästeitä",
  "CookieMessage.settings.body":
    "Voit valita kolmesta eri evästeasetuksesta. Parhaimman verkkosivuston käyttökokemuksen saat valitsemalla vakioasetuksen.",
  "CookieMessage.settings.standard.title": "Vakio (suosituin):",
  "CookieMessage.settings.standard.body":
    "Evästeitä käytetään kirjautumiseen, tilausten tekemiseen, käytön analysointiin, sisällön mukauttamiseen sekä sosiaalisen median ja kolmansien osapuolten tarpeisiin.",
  "CookieMessage.settings.restricted.title": "Rajoitettu:",
  "CookieMessage.settings.restricted.body":
    "Evästeitä käytetään kirjautumiseen, tilauksen tekemiseen sekä käytön analysointiin ja sisällön mukauttamiseen.",
  "CookieMessage.settings.highly_restricted.title": "Erittäin rajoitettu:",
  "CookieMessage.settings.highly_restricted.body":
    "Vain pakolliset evästeet. Evästeitä käytetään ainoastaan kirjautumiseen ja tilausten tekemiseen, varmistaen kohtuullisen verkkosivuston käyttökokemuksen.",
  "CookieMessage.settings.options.title": "Näin toimimme:",
  "CookieMessage.settings.option.1":
    "Käytä evästeitä, jotta sivusto toimii oikein",
  "CookieMessage.settings.option.2": "Analysoi käyttäjän toimintaa",
  "CookieMessage.settings.option.3": "Kerää käyttäjäkohtaisia tilastotietoja",
  "CookieMessage.settings.option.4":
    "Näytä tietoja, jotka saattavat kiinnostaa käyttäjää",
  "CookieMessage.settings.option.5": "Käytä tietoja mainonnan kohdentamisessa",
  "CookieMessage.settings.option.6": "Kerää nimettömiä tilastotietoja",
  "CookieMessage.settings.option.7": "Jaa henkilökohtaisia tietoja",
  "CookieMessage.settings.title": "Evästeasetukset",
  "CookiePage.url": "tietosuoja-ja-evasteet",
};
